



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { IContent } from '../models';
import { CollectionNames } from '../services/meiosis';
import { getUuid } from '../utils/constants';

@Component({
  components: {},
})
export default class AddComponentCard extends Vue {
  @Prop({ default: '' }) public itemkey!: CollectionNames;
  private newItem: Partial<IContent> = {};

  constructor() {
    super();
  }

  private getTranslateKey() {
    return this.$tc(`COMP.${this.itemkey.toUpperCase()}`);
  }

  private resetNewItem() {
    this.newItem = { name: '', type: this.itemkey, id: getUuid() };
  }

  private async addItem() {
    this.$store.actions[this.itemkey].save(this.newItem);
    this.resetNewItem();
    this.$emit('close');
  }

  private async cancel() {
    this.resetNewItem();
    this.$emit('close');
  }

  async mounted(): Promise<void> {
    this.resetNewItem();
  }
}
